import { formatInTimeZone, fromZonedTime } from "date-fns-tz";
import { parseISO } from "date-fns";
import {
  ScheduleSlotSchema,
  SlotDisplayStatus,
  SlotStatus,
} from "../types/booking.type";

const TIME_FORMAT = "h:mm a";

const BLOCKING_STATUSES: SlotStatus[] = ["booked", "pending"];

export function getSlotDisplayStatus(
  slots: ScheduleSlotSchema[],
  index: number
): SlotDisplayStatus {
  const slot = slots[index];
  if (slot.status !== "available") return slot.status;

  const prevBlocks =
    index > 0 && BLOCKING_STATUSES.includes(slots[index - 1].status);
  const nextBlocks =
    index < slots.length - 1 &&
    BLOCKING_STATUSES.includes(slots[index + 1].status);

  if (prevBlocks || nextBlocks) return "cleaning";
  return "available";
}

export const formatDateForInput = (date: Date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const formatSlotDateLabel = (dateStr: string, timezone: string) => {
  const date = fromZonedTime(`${dateStr}T12:00:00`, timezone);
  return formatInTimeZone(date, timezone, "EEEE, MMM d, yyyy");
};

export const formatTimeRange = (
  startTime: string,
  endTime: string,
  timezone: string
) => {
  const start = formatInTimeZone(parseISO(startTime), timezone, TIME_FORMAT);
  const end = formatInTimeZone(parseISO(endTime), timezone, TIME_FORMAT);
  return `${start} – ${end}`;
};
